import "./Blogs.css";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import blogsContext from "../../../context/blogs/blogscontext";

function Blogs() {
  const { blogs } = useContext(blogsContext);

  // Reference articles fallback / enrichment
  const referenceArticles = [
    {
      id: 1,
      tag: "Pregnancy",
      title: "Twins & triplets pregnancy care",
      desc: "Carrying more than one baby needs extra care. Twins and triplets are high-risk pregnancies, and mothers need regular check-ups and proper guidance.",
      url: "Best-Gynecologist-for-Twins-and-Triplets-Pregnancy-Care-in-Malleshwaram"
    },
    {
      id: 2,
      tag: "Pregnancy",
      title: "Effects of thyroid imbalance on mother and baby",
      desc: "Thyroid hormones are essential to a baby's brain development and growth. Left untreated, an imbalance can cause serious complications in pregnancy.",
      url: "effects-of-thyroid-imbalance-on-mother-and-baby"
    },
    {
      id: 3,
      tag: "Pregnancy",
      title: "Liver health matters during pregnancy",
      desc: "Pregnancy alters fat, sugar and protein metabolism, which can worsen underlying liver conditions. Some problems occur only in pregnancy and need immediate attention.",
      url: "Liver-Health-Matters-During-Pregnancy"
    },
    {
      id: 4,
      tag: "Women's health",
      title: "Understanding and managing PCOS",
      desc: "Irregular periods, weight gain and skin problems are often put down to normal life. Frequently the cause is polycystic ovary syndrome, and it can be managed.",
      url: "Best-PCOS-Specialist-in-Malleshwaram"
    },
    {
      id: 5,
      tag: "Women's health",
      title: "Menopause treatment options",
      desc: "Menopause happens naturally between 45 and 55, as the body makes less estrogen and progesterone. Treatment can make the transition considerably easier.",
      url: "Best-Menopause-Treatment-Options-Feel-Better-with-Expert-Care"
    },
    {
      id: 6,
      tag: "Child care",
      title: "Newborn care in the first weeks",
      desc: "Feeding, screening, sleep and the developmental milestones worth watching for — practical guidance for the weeks after you bring your baby home.",
      url: "newborn-Care-tips"
    }
  ];

  const displayList = blogs && blogs.length >= 3 ? blogs.slice(0, 6).map(b => ({
    id: b.id,
    tag: b.tag || "Healthcare",
    title: b.title,
    desc: b.content || b.title2 || "Expert insights and healthcare guidance from our doctors.",
    url: b.url
  })) : referenceArticles;

  return (
    <section className="band tint" id="insights">
      <div className="wrap">
        <p className="eyebrow">Insights</p>
        <h2 className="h-sec">From our doctors.</h2>
        <p className="lede" style={{ marginTop: "20px" }}>
          Plain-language writing on pregnancy, women's health and raising children, from the team at Malleswaram.
        </p>

        <div className="posts">
          {displayList.map((post) => (
            <Link className="post" to={`/blogs/${post.url}`} key={post.id}>
              <span className="tag">{post.tag}</span>
              <h3>{post.title}</h3>
              <p>{post.desc}</p>
              <span className="more">Read the article</span>
            </Link>
          ))}
        </div>

        <p style={{ marginTop: "36px" }}>
          <Link className="btn-ghost" to="/blogs">
            All articles
          </Link>
        </p>
      </div>
    </section>
  );
}

export default Blogs;

